export const FIELD_HEIGHT = 8 * 4;
export const LABEL_WIDTH = 8 * 15;
export const VALUE_WIDTH = 8 * 23;
